/** ``baseUrl`` must have no trailing slash. */
export function advisorV2ThreadListUrl(baseUrl: string, useCase: string, limit: number, offset: number): string {
  const q = new URLSearchParams({
    use_case: useCase,
    limit: String(limit),
    offset: String(offset),
  });
  return `${baseUrl}/v2/chat/threads?${q.toString()}`;
}

/** Org Kin: list all core lanes (omit ``use_case``). Partner portal must use ``advisorV2ThreadListUrl`` with ``partner``. */
export function advisorV2ThreadListAllCoreUrl(baseUrl: string, limit: number, offset: number): string {
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  return `${baseUrl}/v2/chat/threads?${q.toString()}`;
}

export function advisorV2ThreadMessagesUrl(
  baseUrl: string,
  useCase: string,
  threadId: string,
  limit: number,
  offset: number
): string {
  const q = new URLSearchParams({
    use_case: useCase,
    limit: String(limit),
    offset: String(offset),
  });
  return `${baseUrl}/v2/chat/threads/${encodeURIComponent(threadId)}/messages?${q.toString()}`;
}

export function advisorV2ThreadDeleteUrl(baseUrl: string, useCase: string, threadId: string): string {
  const q = new URLSearchParams({ use_case: useCase });
  return `${baseUrl}/v2/chat/threads/${encodeURIComponent(threadId)}?${q.toString()}`;
}

/** ``POST`` target for accepting a handoff offer / the persistent control (PS-1353 route). */
export function advisorV2SupportHandoffUrl(baseUrl: string, useCase: string, threadId: string): string {
  const q = new URLSearchParams({ use_case: useCase });
  return `${baseUrl}/v2/chat/threads/${encodeURIComponent(threadId)}/support-handoff?${q.toString()}`;
}
